import { observer } from 'mobx-react-lite';
import { Layout, Button } from 'Components';
import { useStores } from 'Hooks/useStore';
import { DashboardTabKey } from 'Services/Api/Dashboard/Types';
import { MyResultsWidgets } from 'Pages/Dashboard/tabs/MyResults/MyResults.types';
import { OpenInNewTab } from 'Pages/Dashboard/components';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';
import styles from './Courses.module.scss';

function Courses() {
    const { t } = useTranslation();
    const stores = useStores();
    const { filters } = useDashboardContext();
    const { systemsStore, authStore } = stores;
    const isSuperAdmin = authStore.isCurrentUserSuperAdmin;
    const tenantId = isSuperAdmin ? (filters?.id || 0) : systemsStore.selectedTenant.value;

    return (
        <Layout className={styles.root}>
            <h1 className={styles.header}>{t('courses.quickLinks')}</h1>
            <div className={styles.card}>
                <h3 className={styles.title}>{t('courses.myCourses')}</h3>
                <OpenInNewTab
                    tab={DashboardTabKey.MyResults}
                    widget={MyResultsWidgets.MyCourses}
                    tenantId={tenantId}
                    tooltipPlacement="top"
                    button={(handleButtonClick) => (
                        <Button
                            onClick={handleButtonClick}
                            shape="round"
                            type="primary"
                            className={`${styles.btn} cta-prominent`}>{t('courses.coursesBtn')}</Button>
                    )}
                />
            </div>
        </Layout>
    );
}

export default observer(Courses);